var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3569 40.4964H45.1167L43.6339 43.4621C43.6339 43.4621 52.5309 40.4964 55.4966 44.9449C56.9119 47.0678 61.7478 51.1433 54.0138 53.842C50.7856 54.9684 48.6779 56.1079 43.6339 56.8077C40.8202 57.198 39.1488 59.5515 36.2197 59.7734C30.6182 60.1977 25.8398 53.842 25.8398 53.842L24.3569 40.4964Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6589 41.3817V41.4348L45.7082 41.4151C46.827 40.9672 48.0476 40.7183 49.3702 40.7183C54.9148 40.7183 59.3903 45.1488 59.3903 50.5737C59.3903 55.9983 54.9151 60.3791 49.3702 60.3791C46.6236 60.3791 44.1821 59.2841 42.3506 57.5415L42.3258 57.5179L42.301 57.5415C40.368 59.3835 37.7225 60.479 34.822 60.479C28.8686 60.479 23.9852 55.7485 23.9852 49.8743V31.1407C23.9852 25.3164 28.8688 20.5359 34.822 20.5359C40.7754 20.5359 45.6589 25.2665 45.6589 31.1407V41.3817ZM26.5015 40.4466H26.4656V40.4825V49.8243C26.4656 54.341 30.2088 58.0031 34.822 58.0031C37.1285 58.0031 39.2817 57.1002 40.82 55.5446L40.8401 55.5243L40.8248 55.5001C39.9096 54.0572 39.4011 52.3653 39.4011 50.5237C39.4011 47.4381 40.8758 44.6507 43.1647 42.8587L43.1785 42.848V42.8305V40.4825V40.4466H43.1425H26.5015ZM41.8305 50.5237V50.5597H41.8664H56.8229H56.8588V50.5237C56.8588 46.4567 53.473 43.1442 49.3191 43.1442C47.9857 43.1442 46.7035 43.4955 45.6263 44.0979L45.6256 44.0983C44.6003 44.7004 43.7287 45.5032 43.062 46.4567L43.0616 46.4573C42.2921 47.612 41.8305 49.0176 41.8305 50.5237Z",
    fill: "#8E8CEE",
    stroke: "#8E8CEE",
    strokeWidth: 0.0718644
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.fc074615fbed3e3c9a55da4736ee57bf.svg";
export { ForwardRef as ReactComponent };